import React from 'react';
import { GmaisModal } from '../../../../components/GmaisModal';
import { LongSteelOrders3Img, LongSteelOrders3ModalContent } from './styles';
import GIF_LONG_STEEL_ORDERS_3 from '../../../../assets/images/long-steel-orders-3/homepage-modal.gif';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../routes';
export interface LongSteelOrders3HomepageModalProps {
  onCloseModal: () => void;
  dontShowThisAgain: () => Promise<void>;
}

export const LongSteelOrders3HomepageModal = ({
  onCloseModal,
  dontShowThisAgain
}: LongSteelOrders3HomepageModalProps) => {
  const history = useHistory();
  const userFabricationBP = useSelector(
    (app: ApplicationState) => app.user.roles.fabricationViewCustomers || []
  );
  const isFabricationUser = userFabricationBP.length > 0;

  function closeModal() {
    onCloseModal();
  }

  function accessExperience() {
    onCloseModal();
    // if user has fabrication, redirect to choose between
    if (isFabricationUser) {
      history.push(`${ERoutes.ORDERS}/steel-type-choose`);
      return;
    }
    // user h as no fabrication, navigate directly

    history.push(`${ERoutes.ORDERS}/long-steel`);
  }

  return (
    <GmaisModal
      onDismissModal={closeModal}
      title={
        'Nova experiência de pedidos com as\ninformações que você já conhece'
      }
      dontShowAgainCheckBox={true}
      dontShowThisAgain={dontShowThisAgain}
      buttons={{
        action: {
          title: 'Acessar a experiência',
          callback: accessExperience
        },
        close: {
          title: 'Fechar',
          callback: closeModal
        }
      }}
    >
      <LongSteelOrders3ModalContent>
        <span>
          Confira todas as informações que você já usa dos seus{' '}
          <strong>pedidos abertos ou faturados</strong> com maior facilidade,
          detalhes e personalização.
        </span>
        <LongSteelOrders3Img src={GIF_LONG_STEEL_ORDERS_3} />
      </LongSteelOrders3ModalContent>
    </GmaisModal>
  );
};
